import { InjectionKey } from 'vue';
import { Auth0Manager } from '@/auth';

export const InjectionKeys = Object.freeze({
  Auth: Symbol('Auth') as InjectionKey<Auth0Manager>
});
